var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('App',[_c('main',{staticClass:"main-layout"},[_c('div',{staticClass:"main-layout__content"},[_c('Nuxt')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }